/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CheckoutMarkup
 */
export interface CheckoutMarkup {
  /**
   *
   * @type {number}
   * @memberof CheckoutMarkup
   */
  percent: number;
  /**
   *
   * @type {number}
   * @memberof CheckoutMarkup
   */
  flat: number;
}

/**
 * Check if a given object implements the CheckoutMarkup interface.
 */
export function instanceOfCheckoutMarkup(
  value: object,
): value is CheckoutMarkup {
  if (!("percent" in value) || value["percent"] === undefined) return false;
  if (!("flat" in value) || value["flat"] === undefined) return false;
  return true;
}

export function CheckoutMarkupFromJSON(json: any): CheckoutMarkup {
  return CheckoutMarkupFromJSONTyped(json, false);
}

export function CheckoutMarkupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CheckoutMarkup {
  if (json == null) {
    return json;
  }
  return {
    percent: json["percent"],
    flat: json["flat"],
  };
}

export function CheckoutMarkupToJSON(json: any): CheckoutMarkup {
  return CheckoutMarkupToJSONTyped(json, false);
}

export function CheckoutMarkupToJSONTyped(
  value?: CheckoutMarkup | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    percent: value["percent"],
    flat: value["flat"],
  };
}
